import { CustomDataAttributeCategory } from './../../models/custom-data/custom-data-attribute-category';
import { TransactionForms } from './../../shared/forms/transaction-forms';
import { TransactionTypeEnum } from './../../models/transaction-type.enum';
import { CustomDataAttributeType } from './../../models/custom-data/custom-data-attribute-type';
import { Injectable, OnInit } from '@angular/core';
import { DataService } from '../data-services/data.service';
import { Observable } from 'rxjs';
import { ICustomDataAttribute } from './../../models/custom-data/custom-data-attribute';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Injectable({
  providedIn: 'root',
})
export class AttributeService extends DataService<ICustomDataAttribute> {
  getCategoryFieldsById(
    category: string,
    categoryId: string
  ): Observable<Array<ICustomDataAttribute>> {
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      `/category/${category}/category-id/${categoryId}`
    )}`;
    return this.http.get<Array<ICustomDataAttribute>>(`${url}`);
  }

  protected collectionname = 'attributes';

  getAttributesByOrganization(
    organizationId: string
  ): Observable<Array<ICustomDataAttribute>> {
    //    if (!organizationId) {
    organizationId = this.organization.organizationId;
    //   }
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      'getByOrganization'
    )}/${organizationId}`;
    return this.http.get<Array<ICustomDataAttribute>>(`${url}`);
  }

  //attributefields
  attribueCategoryType = {
    [CustomDataAttributeCategory.PaymentRequest]:
      TransactionForms.FundsTransfer, //may need only 1
    [TransactionTypeEnum.BudgetTransfer]: TransactionForms.FundsTransfer, // may need only 1
    [TransactionTypeEnum.Expense]: TransactionForms.Expense,
    [TransactionTypeEnum.Invoice]: TransactionForms.Invoice,
    [TransactionTypeEnum.Receipt]: TransactionForms.Receipt,
    [TransactionTypeEnum.Requisition]: TransactionForms.Request,
    [TransactionTypeEnum.Transaction]: TransactionForms.Transaction,
    [TransactionTypeEnum.Transfer]: TransactionForms.Transfer,
  };

  private setupCustomField(attr: ICustomDataAttribute): FormlyFieldConfig {
    let config = {
      key: `attributes.${attr.key}`,
      className: 'col-6',
      type: attr.type,
      props: {
        label: attr.label,
        // rows: 5,
        // options: attr.options,
      },
    } as FormlyFieldConfig;
    if (config.type === 'checkbox') config.defaultValue = false;
    if (config.type === 'radio') config.props.inline = true;
    if (config.type === 'checkbox') {
      attr.options = undefined;
      config.props.options = undefined;
      config.validators = {
        required: {
          expression: (control) => control.value === true,
          message: 'This field is required',
        },
      };
    }

    if (attr.maximumLength) config.props.maxLength = attr.maximumLength;
    if (attr.minimumLength) config.props.minLength = attr.minimumLength;
    if (attr.type === CustomDataAttributeType.TextArea)
      config.props.rows = !!attr.rows ? attr.rows : 5;
    if (attr.required) config.props.required = true;

    if (attr.options) {
      const values = attr.options.map((option) => {
        return { label: option, value: option };
      });

      config.props.options = values;
    }

    return config;
  }

  createCustomFields(
    attributes: Array<ICustomDataAttribute>
  ): FormlyFieldConfig[] {
    if (!attributes) return;

    var customFields: Array<FormlyFieldConfig> = attributes.map((attr) => {
      return this.setupCustomField(attr);
    });

    return customFields;
  }
}
